const HelpButtonStyle = (theme) => {
  const { defaultFont, palette, header } = theme;

  return {
    buttonStyle: {
      ...header.button,
      ...defaultFont,
      paddingBottom: "11px",
      "& span": {
        flexDirection: "column",
        paddingTop: "4px",
      },
    },
    paper: {
      background: palette.topBar.activeBkColor,
      overflow: "hidden",
    },
    gridContainer: {
      margin: "5px",
      "& div": {
        borderTop: "1px solid #999",
        flexWrap: "inherit",
        alignItems: "center",
        "& div": {
          borderTop: "none",
          "& p": {
            color: "white",
            fontFamily: defaultFont.fontFamily,
            fontSize: defaultFont.fontSize,
            flexWrap: "inherit",
            borderTop: "none",
          },
        },
      },
    },
    gridItem: {
      paddingBottom: "23px !important",
      "& div": {
        backgroundColor: palette.topBar.activeBkColor,
      },
    },
  };
};

export default HelpButtonStyle;
